// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3euV9","col":"CardReaderDesc_col__1P0-Q","label":"CardReaderDesc_label__2ntyZ"};